import { Checkbox as Check, FormControlLabel } from "@mui/material";
import { mdiCheckboxBlankCircleOutline, mdiCheckboxMarkedCircleOutline } from "@mdi/js";
import { Component, default as React } from "react";
import { Icon } from ".";
import * as StyleGlobal from "../infra/styleGlobal";
import { TooltipCustom } from "../infra/styleGlobal";

export default class Checkbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }


  renderCheck() {
    let props = this.props;
    
    let { checked = false, onChange } = this.props
    if (!props.label) {
      return (
        <Check
          checked={checked}
          onChange={onChange}
          checkedIcon={<Icon size={1} color={StyleGlobal.preto} path={mdiCheckboxMarkedCircleOutline} />}
          icon={<Icon size={1} color={StyleGlobal.preto} path={mdiCheckboxBlankCircleOutline} />}
        />
      )
    }

    return (
      <FormControlLabel
        control={
          <Check
            checked={checked}
            onChange={onChange}
            checkedIcon={<Icon size={1} color={StyleGlobal.preto} path={mdiCheckboxMarkedCircleOutline} />}
            icon={<Icon size={1} color={StyleGlobal.preto} path={mdiCheckboxBlankCircleOutline} />}
          />
        }
        label={props.label ? props.label : false}
      />
    )
  }
  render() {
    let props = this.props;
    if (props.tooltip) {
      return (
        <TooltipCustom
          title={props.tooltip}  >
          {this.renderCheck()}
        </TooltipCustom>
      )
    } else {
      return (
        this.renderCheck()
      )
    }
  }
}



{/* <CheckBox
checked={objedit.flag_pode_add_roteiro}
onChange={event => { Util.handleChange(this, "objedit", "flag_pode_add_roteiro", event.target.checked) }}
label={"Disponível para adicionar ao roteiro"}
>
</CheckBox> */}